import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
}))

export const List = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  width: '80rem',
}))

export const Item = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  gap: theme.space['16'],
  minHeight: '6.4rem',
  padding: theme.space['8'],
  width: '100%',
}))

export const ServiceIconContainer = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.gray300,
  borderRadius: theme.border.radius['circle'],
  borderStyle: 'solid',
  borderWidth: theme.border.size['1'],
  color: theme.colors.gray300,
  display: 'flex',
  flexShrink: 0,
  height: '4.8rem',
  justifyContent: 'center',
  width: '4.8rem',
}))

export const ServiceIcon = styled.img({
  height: '4.8rem',
  objectFit: 'contain',
  width: '4.8rem',
})

export const LinkInfo = styled.div(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
}))

export const ServiceName = styled.span({
  fontSize: '1.4rem',
  fontWeight: 700,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const LinkUrl = styled.a(({ theme }) => ({
  '&:hover': {
    textDecoration: 'underline',
  },
  color: theme.colors.black400,
  cursor: 'pointer',
  fontSize: '1.4rem',
  overflow: 'hidden',
  textDecoration: 'none',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const Actions = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  gap: theme.space['8'],
}))

export const SkeletonLinkInfo = styled.div(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: theme.space['6'],
  minWidth: 0,
}))
